// extracted by mini-css-extract-plugin
module.exports = {"w1psf6ov":"w1psf6ov","tm4q1bl":"tm4q1bl","cwgwn50":"cwgwn50","i1tznitr":"i1tznitr","im6bhq":"im6bhq"};